import { statusLabel } from "../lib/data";

export const StatusBadge = ({ status }) => {
  return (
    <span
      className={`badge-${status} inline-block px-3 py-1 text-[11px] font-bold uppercase tracking-wider rounded-full`}
      data-testid={`status-badge-${status}`}
    >
      {statusLabel(status)}
    </span>
  );
};
